import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HomeHero() {
  const featured = movies.find((m) => m.featured) ?? movies[0];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={featured.backdrop}
          alt={`${featured.title} 剧照背景`}
          title={`${featured.title} 剧情介绍与角色`}
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/60 to-primary-950/85"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-accent-500/20 px-3 py-1 font-label text-xs text-accent-200">
            <i className="ri-fire-line"></i> 本站焦点作品
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            玉女心经2 · 影视作品简介与剧情解析
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200/95 md:text-base md:leading-8">
            以《玉女心经2》为核心，汇集详细影视剧情介绍、角色信息与作品背景资料。从剧情时间线到人物关系，帮你把每一部作品看得更明白、更有滋味。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to={`/detail/${featured.id}`}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i> 查看焦点作品
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-200/40 bg-background-50/10 px-6 py-3 font-label text-sm text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 whitespace-nowrap"
            >
              <i className="ri-layout-grid-line text-lg"></i> 浏览影视分类
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}